export enum CameraPermissionStatus {
  ALLOWED = 'Allowed',
  NOT_ALLOWED = 'Not Allowed',
}
